exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-8099726c]{background-color:$first;text-align:center;overflow:hidden}.avatar[data-v-8099726c],.avatar img[data-v-8099726c]{width:100%;height:100%}.shape-circle[data-v-8099726c]{border-radius:50%}", ""]);

// exports
